/* ============================================================
   LA FABRIQUE DES MINIS — moteur d'achat 2026
   Fiche produit : modèles product.lfdm-couches et product.lfdm-standard.

   Auto-adaptatif : tout vient des attributs data-* posés par
   sections/lfdm-achat26.liquid. Le script ne connaît aucun produit.

   Contrat de données sur l'élément .buy
   -------------------------------------
   Séparateur d'enregistrement : ~~   ·   séparateur de champ : |

     data-sizes      cle|poidsMin|poidsMax        (1er axe de variante)
     data-formats    titre|sous-titre             (2e axe de variante)
     data-variants   cle|iFormat|prixCts|unites|idVariante|dispo|idPlan|prixPlanCts|iVisuel
     data-packs      cle:nbParLot                 (informatif)
     data-axis-size  1 / 0        data-axis-fmt  1 / 0
     data-unit       mot de l'unité vendue (« couche »)
     data-unit-art   son article (« la »)
     data-unit-mode  unit | per100 | none
     data-free       seuil de franco en centimes (0 = pas de mention)

   Tout le reste (libellés des boutons, mentions) est passé en data-lbl-*.

   Écran étroit : les sélecteurs (.ctl) sont DÉPLACÉS dans la feuille
   d'achat à l'ouverture et remis à leur place à la fermeture, repérée
   par un commentaire d'ancrage. Un seul moteur, jamais de doublon d'état.
   ============================================================ */
(function () {
  'use strict';

  var ROOTS = document.querySelectorAll('[data-lfdm-buy]');
  if (!ROOTS.length) return;

  var STICK = document.getElementById('lfdmStick');
  var SHEET = document.getElementById('lfdmBSheet');
  var SH_BODY = SHEET ? SHEET.querySelector('[data-bs-body]') : null;
  var SH_TTL = SHEET ? SHEET.querySelector('[data-bs-title]') : null;
  var SH_IMG = SHEET ? SHEET.querySelector('[data-bs-img]') : null;
  var ST_T = STICK ? STICK.querySelector('[data-st-title]') : null;
  var ST_S = STICK ? STICK.querySelector('[data-st-sub]') : null;
  var ST_B = STICK ? STICK.querySelector('[data-st-btn]') : null;

  var CUR = null; /* bloc d'achat courant */

  function eur(c) {
    return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rows(s, n) {
    return String(s || '').split('~~').filter(Boolean).map(function (r) { return r.split('|'); }).filter(function (r) {
      return !n || r.length >= n;
    });
  }
  function isMob() { return window.innerWidth < 900; }

  /* ============================================================
     UN BLOC D'ACHAT
     ============================================================ */
  function initBuy(root) {
    var D = root.dataset;
    var unit = D.unit || '';
    var art = D.unitArt || '';
    var umode = D.unitMode || 'unit';
    var hasSize = D.axisSize === '1';
    var free = parseInt(D.free, 10) || 0;
    var maxQty = parseInt(D.maxQty, 10) || 9;

    var sizes = rows(D.sizes, 1).map(function (r) { return { k: r[0], mi: r[1] || '', ma: r[2] || '' }; });
    var fmts = rows(D.formats, 1).map(function (r) { return { t: r[0], s: r[1] || '' }; });
    if (!fmts.length) fmts = [{ t: D.lblFormat || 'Format', s: '' }];
    var vars = rows(D.variants, 6).map(function (r) {
      return {
        k: r[0], f: +r[1], p: +r[2], u: +r[3], id: r[4], ok: r[5] === '1',
        pl: r[6] || '', pp: +r[7] || 0, img: r[8] === '' || r[8] == null ? -1 : +r[8]
      };
    });

    var mode = 'one', size = hasSize ? null : '*', fmt = null, qty = 1;

    var ctl = root.querySelector('[data-ctl]');
    var anchor = document.createComment('ctl');
    ctl.parentNode.insertBefore(anchor, ctl);

    var q = function (s) { return ctl.querySelector(s); };
    var R = {
      tiles: q('[data-tiles]'), fmts: q('[data-fmts]'), qtyGrp: q('[data-grp="qty"]'),
      sizeGrp: q('[data-grp="size"]'), fmtGrp: q('[data-grp="fmt"]'),
      abo: q('[data-abo]'), modes: [].slice.call(ctl.querySelectorAll('[data-mode]')),
      lab: q('[data-lab-size]'), qv: q('[data-qv]'), cta: q('[data-cta]'),
      tot: q('[data-tot]'), sumlab: q('[data-sumlab]'), up: q('[data-unitp]'),
      cnt: q('[data-count]'), save: q('[data-qsave]'), err: q('[data-err]'),
      note: q('[data-cta-note]')
    };
    var title = (D.title || '').trim();

    var V = function (k, f) {
      for (var i = 0; i < vars.length; i++) if (vars[i].k === k && vars[i].f === f) return vars[i];
      return null;
    };
    var ok = function (v) { return !!v && v.ok && (mode === 'one' || !!v.pl); };
    var sizeOk = function (k) {
      return vars.some(function (v) { return v.k === k && (fmt === null || v.f === fmt) && ok(v); });
    };
    var fmtOk = function (f) {
      return vars.some(function (v) { return v.f === f && (size === null || v.k === size) && ok(v); });
    };
    var TL = function () { return [].slice.call(R.tiles ? R.tiles.children : []); };
    var FL = function () { return [].slice.call(R.fmts ? R.fmts.children : []); };

    /* ---------- construction des sélecteurs ---------- */
    function build() {
      if (hasSize && R.tiles) {
        /* clés longues (« Éco-recharge 1 L ») : tuiles à la largeur du texte */
        var longKey = sizes.some(function (s) { return s.k.length > 4; });
        R.tiles.classList.toggle('tiles--wide', longKey);
        R.tiles.innerHTML = sizes.map(function (s) {
          var any = vars.some(function (v) { return v.k === s.k && v.ok; });
          var sub = s.ma ? s.mi + '–' + s.ma + ' kg' : (s.mi ? s.mi + ' kg +' : '');
          return '<button type="button" class="tile" data-s="' + esc(s.k) + '"' + (any ? '' : ' disabled') + '>' +
            '<b>' + esc(s.k) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</button>';
        }).join('');
      }
      if (R.fmts) {
        R.fmts.innerHTML = fmts.map(function (f, i) {
          return '<button type="button" class="oc oc--wrap" data-f="' + i + '">' +
            '<span class="oc__r"></span>' +
            '<span><span class="oc__t">' + esc(f.t) + '</span>' +
            (f.s ? '<span class="oc__s">' + esc(f.s) + '</span>' : '') + '</span>' +
            '<span class="oc__p"><b data-fp>—</b></span></button>';
        }).join('');
      }
    }

    /* ---------- filtrage croisé ---------- */
    function sync() {
      if (hasSize && R.tiles) {
        TL().forEach(function (t) {
          var can = sizeOk(t.dataset.s);
          t.classList.toggle('off', !can);
          t.disabled = !can;
        });
        if (size && !sizeOk(size)) size = null;
      }
      /* un format sans aucune variante dans le mode courant est masqué —
         sauf si AUCUN format n'en a (produit entier indisponible) : on les
         montre alors grisés plutôt que de vider le bloc. */
      var anyFmt = fmts.some(function (_, i) {
        return vars.some(function (v) { return v.f === i && ok(v); });
      });
      FL().forEach(function (o) {
        var f = +o.dataset.f;
        o.hidden = anyFmt && !vars.some(function (v) { return v.f === f && ok(v); });
        var can = fmtOk(f);
        o.classList.toggle('off', !can);
        o.disabled = !can;
        var v = size !== null ? V(size, f) : vars.filter(function (x) { return x.f === f && ok(x); })[0];
        var pel = o.querySelector('[data-fp]');
        if (ok(v)) {
          pel.innerHTML = (size === null ? '<small>dès </small>' : '') + eur(mode === 'sub' ? v.pp : v.p);
        } else { pel.textContent = '—'; }
      });
      if (fmt !== null && !fmtOk(fmt)) fmt = null;
      if (fmt === null) {
        for (var i = 0; i < fmts.length; i++) { if (fmtOk(i)) { fmt = i; break; } }
      }
      FL().forEach(function (o) { o.classList.toggle('on', +o.dataset.f === fmt); });
      if (hasSize) TL().forEach(function (t) { t.classList.toggle('on', size === t.dataset.s); });
      if (R.lab) R.lab.textContent = size || '—';
      /* un seul format réellement proposé : on masque le bloc */
      if (R.fmtGrp) {
        var shown = FL().filter(function (o) { return !o.hidden; }).length;
        R.fmtGrp.hidden = fmts.length < 2 || shown < 2;
      }
      if (R.qtyGrp) R.qtyGrp.hidden = mode === 'sub';
      if (R.abo) R.abo.classList.toggle('on', mode === 'sub');
      render();
    }

    /* ---------- récapitulatif ---------- */
    function render() {
      var v = (size !== null && fmt !== null) ? V(size, fmt) : null;
      if (!ok(v)) {
        R.cta.disabled = true;
        R.cta.textContent = hasSize ? (D.lblChooseSize || 'Choisissez une taille') : (D.lblChooseFmt || 'Choisissez un format');
        R.tot.textContent = '—'; R.sumlab.textContent = '—';
        if (R.up) R.up.textContent = '';
        if (R.cnt) R.cnt.textContent = '';
        if (R.err) R.err.classList.toggle('on', size !== null && fmt !== null);
        if (R.save) R.save.hidden = true;
        root._state = null;
        paintStick();
        return;
      }
      if (R.err) R.err.classList.remove('on');

      var n = mode === 'sub' ? 1 : qty;
      var base = mode === 'sub' ? v.pp : v.p;
      var total = base * n;
      var f = fmts[fmt] || { t: '' };
      var suffix = mode === 'sub' ? (D.subSuffix || '/mois') : '';

      var lab = f.t + (hasSize ? ' · ' + (D.lblSizeShort || '') + ' ' + size : '') +
        (mode === 'sub' ? ' · ' + (D.subEvery || 'tous les mois') : '');
      R.sumlab.textContent = lab.replace(/\s+/g, ' ').trim();
      R.tot.innerHTML = eur(total) +
        (mode === 'sub' ? '<u>' + esc(suffix) + '</u><s>' + eur(v.p * n) + '</s>' : '');

      /* prix à l'unité : seulement si le produit sait combien il en contient */
      var units = v.u * n;
      if (R.up && R.cnt) {
        if (units > 0 && umode === 'per100') {
          R.up.textContent = eur(Math.round(total / (units / 100))) + ' ' + art + ' ' + unit;
          R.cnt.textContent = units >= 1000 ? (units / 1000).toLocaleString('fr-FR') + ' L' : units + ' ml';
        } else if (units > 0 && umode === 'unit' && unit) {
          R.up.textContent = eur(Math.round(total / units * 100) / 100) + ' ' + art + ' ' + unit;
          R.cnt.textContent = units + ' ' + unit + (units > 1 ? 's' : '');
        } else {
          R.up.textContent = ''; R.cnt.textContent = '';
        }
      }

      R.cta.disabled = false;
      R.cta.textContent = (mode === 'sub' ? (D.lblSub || "M'abonner") : (D.lblOne || 'Ajouter au panier')) +
        ' — ' + eur(total) + suffix;
      if (R.note) R.note.textContent = mode === 'sub' ? (D.noteSub || '') : (D.noteOne || '');
      if (R.save) {
        R.save.hidden = !free || total < free || mode === 'sub';
        R.save.textContent = D.freeLabel || 'Livraison offerte';
      }

      root._state = {
        sub: R.sumlab.textContent,
        cta: (mode === 'sub' ? (D.lblSub || "M'abonner") : (D.lblOne || 'Ajouter')) + ' — ' + eur(total) + suffix,
        id: v.id, plan: v.pl, qty: n
      };
      showShot(v.img);
      paintStick();
    }

    /* ---------- galerie liée à la variante ---------- */
    function showShot(i) {
      if (i == null || i < 0) return;
      var g = root.querySelector('[data-gal]');
      if (!g) return;
      var shots = g.querySelectorAll('[data-shot]');
      if (!shots[i]) return;
      [].forEach.call(shots, function (s, j) { s.classList.toggle('on', j === i); });
      [].forEach.call(g.querySelectorAll('[data-go]'), function (t, j) { t.classList.toggle('on', j === i); });
    }

    /* ---------- barre collante ---------- */
    function paintStick() {
      if (CUR !== root || !STICK) return;
      var st = root._state;
      if (ST_T) ST_T.textContent = title;
      if (!st) {
        if (ST_S) ST_S.textContent = hasSize ? (D.lblChooseSize || 'Choisissez une taille') : (D.lblChooseFmt || 'Choisissez un format');
        if (ST_B) ST_B.textContent = D.lblStick || 'Choisir';
      } else {
        if (ST_S) ST_S.textContent = st.sub;
        if (ST_B) ST_B.textContent = st.cta;
      }
      syncStickH();
    }

    /* ---------- ajout au panier ---------- */
    function add(btn) {
      var st = root._state;
      if (!st) return;
      var item = { id: st.id, quantity: st.qty };
      if (mode === 'sub' && st.plan) item.selling_plan = st.plan;
      var old = btn.textContent;
      btn.disabled = true;
      var done = function () {
        btn.disabled = false;
        btn.textContent = D.lblAdded || 'Ajouté au panier ✓';
        setTimeout(function () { btn.textContent = old; }, 1600);
        if (SHEET && SHEET.classList.contains('on')) setTimeout(closeSheet, 700);
      };
      if (window.LFDM && window.LFDM.cartAdd) {
        window.LFDM.cartAdd(item, D.lblAdded || 'Ajouté au panier')
          .then(done)
          .catch(function () { btn.disabled = false; btn.textContent = old; });
      } else {
        /* repli : formulaire natif si lfdm-cart.js n'est pas chargé */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function () { done(); window.location.href = '/cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = old; });
      }
    }

    /* ---------- événements ---------- */
    build();
    ctl.addEventListener('click', function (e) {
      var t = e.target.closest('.tile');
      var o = e.target.closest('.oc');
      var m = e.target.closest('[data-mode]');
      var b = e.target.closest('[data-q]');
      var c = e.target.closest('[data-cta]');
      if (t && !t.disabled) { size = size === t.dataset.s ? null : t.dataset.s; sync(); }
      else if (o && !o.disabled) { fmt = +o.dataset.f; sync(); }
      else if (m) {
        mode = m.dataset.mode; qty = 1;
        if (R.qv) R.qv.textContent = 1;
        R.modes.forEach(function (x) {
          x.classList.toggle('on', x === m);
          x.setAttribute('aria-selected', x === m ? 'true' : 'false');
        });
        sync();
      } else if (b) {
        qty = Math.min(maxQty, Math.max(1, qty + (+b.dataset.q)));
        if (R.qv) R.qv.textContent = qty;
        render();
      } else if (c && !c.disabled) { add(c); }
    });

    root._ctl = ctl;
    root._anchor = anchor;
    root._title = title;
    root._sync = sync;
    root._add = function (btn) { add(btn); };
    root._sizes = sizes;
    root._pick = function (k) {
      if (!R.tiles) return;
      var t = R.tiles.querySelector('.tile[data-s="' + k.replace(/"/g, '\\"') + '"]');
      if (t && !t.disabled) {
        size = k; sync();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    if (!CUR) CUR = root;
    sync();
  }

  [].forEach.call(ROOTS, initBuy);

  /* ============================================================
     GALERIE — vignettes
     ============================================================ */
  [].forEach.call(document.querySelectorAll('[data-gal]'), function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (!b) return;
      var i = +b.dataset.go;
      [].forEach.call(g.querySelectorAll('[data-shot]'), function (s, j) { s.classList.toggle('on', j === i); });
      [].forEach.call(g.querySelectorAll('[data-go]'), function (t) { t.classList.toggle('on', t === b); });
    });
  });

  /* ============================================================
     BARRE COLLANTE
     Bureau : visible dès le chargement.
     Mobile : masquée, elle apparaît au défilement vers le bas
     (au-delà de 240 px) et disparaît au défilement vers le haut.
     ============================================================ */
  function setTabH() {
    var t = document.querySelector('.tabbar');
    var h = t && getComputedStyle(t).display !== 'none' ? t.offsetHeight + 12 : 0;
    document.documentElement.style.setProperty('--tabh', h + 'px');
  }
  function syncStickH() {
    if (!STICK) return;
    document.documentElement.style.setProperty('--stickh',
      (STICK.classList.contains('on') && isMob() ? STICK.offsetHeight : 0) + 'px');
  }
  function showStick(on) {
    if (!STICK) return;
    STICK.classList.toggle('on', on);
    syncStickH();
  }
  var lastY = window.scrollY;
  function onScroll() {
    if (!STICK || (SHEET && SHEET.classList.contains('on'))) return;
    if (!isMob()) { showStick(true); lastY = window.scrollY; return; }
    var y = Math.max(0, window.scrollY), d = y - lastY;
    if (Math.abs(d) < 8) return;
    if (d > 0 && y > 240) showStick(true);
    else if (d < 0) showStick(false);
    lastY = y;
  }
  function setupStick() { setTabH(); showStick(!isMob()); lastY = window.scrollY; syncStickH(); }
  if (STICK) {
    setupStick();
    window.addEventListener('resize', setupStick);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (ST_B) ST_B.addEventListener('click', function () {
      if (!CUR) return;
      if (CUR._state) { CUR._add(ST_B); return; }
      if (isMob()) openSheet();
      else CUR.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ============================================================
     FEUILLE D'ACHAT (écran étroit)
     ============================================================ */
  function openSheet() {
    if (!SHEET || !CUR) return;
    SH_BODY.appendChild(CUR._ctl);
    if (SH_TTL) SH_TTL.textContent = CUR._title;
    if (SH_IMG) {
      var shot = CUR.querySelector('[data-shot].on img');
      SH_IMG.innerHTML = shot ? '<img src="' + shot.getAttribute('src') + '" alt="">' : '';
    }
    SHEET.classList.add('on');
    if (STICK) STICK.classList.add('hide');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!SHEET || !CUR) return;
    CUR._anchor.parentNode.insertBefore(CUR._ctl, CUR._anchor.nextSibling);
    SHEET.classList.remove('on');
    if (STICK) STICK.classList.remove('hide');
    document.documentElement.style.overflow = '';
    lastY = window.scrollY;
  }
  if (SHEET) {
    SHEET.addEventListener('click', function (e) {
      if (e.target.closest('[data-bs-close]') || e.target.classList.contains('bsheet__scrim')) closeSheet();
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && SHEET.classList.contains('on')) closeSheet();
    });
  }

  /* ============================================================
     GUIDE DES TAILLES
     Le curseur lit les repères de poids du bloc d'achat : aucune
     donnée en double, la section se tait si le produit n'en a pas.
     ============================================================ */
  (function () {
    var box = document.querySelector('[data-calc]');
    if (!box || !CUR) return;
    var band = CUR._sizes.filter(function (s) { return s.mi !== ''; });
    if (!band.length) { box.hidden = true; return; }

    var r = box.querySelector('[data-calc-range]');
    var vEl = box.querySelector('[data-calc-val]');
    var tEl = box.querySelector('[data-calc-size]');
    var pEl = box.querySelector('[data-calc-txt]');
    var go = box.querySelector('[data-calc-go]');
    if (!r) return;

    var min = parseFloat(band[0].mi) || 2;
    var last = band[band.length - 1];
    var max = parseFloat(last.ma || last.mi) + 6;
    r.min = min; r.max = Math.round(max); r.value = Math.round((min + max) / 3);

    var cur = band[0].k;
    var word = box.dataset.calcWord || 'Taille';
    function up() {
      var k = parseFloat(r.value);
      vEl.textContent = k.toLocaleString('fr-FR') + ' kg';
      var hit = band.filter(function (s) {
        var a = parseFloat(s.mi), b = s.ma ? parseFloat(s.ma) : 999;
        return k >= a && k < b;
      })[0] || band[band.length - 1];
      cur = hit.k;
      tEl.textContent = cur;
      pEl.textContent = word + ' ' + cur + ' — ' + (box.dataset.calcHint || 'conseillée pour') + ' ' +
        k.toLocaleString('fr-FR') + ' kg. ' + (box.dataset.calcTip || '');
    }
    r.addEventListener('input', up);
    up();
    if (go) go.addEventListener('click', function () {
      if (SHEET && SHEET.classList.contains('on')) closeSheet();
      CUR._pick(cur);
    });
  }());

  /* ============================================================
     VOLETS — un seul ouvert à la fois par groupe
     ============================================================ */
  [].forEach.call(document.querySelectorAll('.acc'), function (a) {
    a.addEventListener('toggle', function (e) {
      if (e.target.open) {
        [].forEach.call(a.querySelectorAll('details'), function (d) { if (d !== e.target) d.open = false; });
      }
    }, true);
  });
}());
